import { RevealItem, ScrollReveal } from '#/components/common/ScrollReveal'
import { TextAnimate } from '#/components/common/TextAnimate'
import headerIcon from '#/assets/header-icon.svg'
import { LucideCheckCircle2 } from 'lucide-react'
import type { Course } from '#/features/courses/types/course.types'

interface CourseKeyFeaturesSectionProps {
  course?: Course
}

export default function CourseKeyFeaturesSection({
  course,
}: CourseKeyFeaturesSectionProps) {
  const keyFeatures = course?.keyFeatures || []

  if (keyFeatures.length === 0) {
    return null
  }

  return (
    <section className="relative w-full py-20 noir-section" id="key-features">
      <div className="container mx-auto flex flex-col gap-14">
        {/* Header */}
        <ScrollReveal className="flex flex-col items-start gap-4 max-w-2xl">
          <RevealItem>
            <img alt="" src={headerIcon} />
          </RevealItem>
          <RevealItem>
            <h3 className="text-sm font-semibold uppercase tracking-[0.3em] text-primary-300">
              KEY FEATURES
            </h3>
          </RevealItem>
          <RevealItem className="w-full">
            <TextAnimate
              by="word"
              animation="blurInUp"
              as="h2"
              className="text-4xl font-bold text-white sm:text-5xl"
            >
              Everything You Get With This Course
            </TextAnimate>
          </RevealItem>
        </ScrollReveal>
        <div className="h-px w-full bg-linear-to-r from-transparent via-primary-500/30 to-transparent" />

        {/* Checklist grid */}
        <ScrollReveal
          className="grid grid-cols-1 gap-x-16 gap-y-7 md:grid-cols-2"
          stagger={0.1}
        >
          {keyFeatures.map((feature) => (
            <RevealItem key={feature.id || feature.title}>
              <div className="flex gap-4">
                <div className="mt-0.5 flex-shrink-0">
                  <LucideCheckCircle2 className="text-2xl text-primary-500" />
                </div>
                <div className="flex flex-col gap-1">
                  <h3 className="text-lg font-bold text-white leading-snug">
                    {feature.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-neutral-400">
                    {feature.description}
                  </p>
                </div>
              </div>
            </RevealItem>
          ))}
        </ScrollReveal>
      </div>
    </section>
  )
}
